const PURCHASE_ACTION_SELECTOR = '.product-form__controls-group--submit';
const PURCHASE_ACTION_ATTRIBUTE = 'data-purchase-action-visible';

export const createPurchaseOverlayGuard = ({
  document: documentObject = globalThis.document,
  IntersectionObserver: Observer = globalThis.IntersectionObserver,
} = {}) => {
  const root = documentObject?.documentElement;
  const purchaseAction = documentObject?.querySelector?.(PURCHASE_ACTION_SELECTOR);

  if (!root || !purchaseAction || typeof Observer !== 'function') {
    return { destroy() {} };
  }

  const observer = new Observer((entries) => {
    const purchaseActionVisible = entries.some((entry) => entry.isIntersecting);
    root.toggleAttribute(PURCHASE_ACTION_ATTRIBUTE, purchaseActionVisible);
  });

  observer.observe(purchaseAction);

  return {
    destroy() {
      observer.disconnect();
      root.toggleAttribute(PURCHASE_ACTION_ATTRIBUTE, false);
    },
  };
};

const initializePurchaseOverlayGuard = () => createPurchaseOverlayGuard();

if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializePurchaseOverlayGuard, { once: true });
  } else {
    initializePurchaseOverlayGuard();
  }
}
